import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@sectepe/ui';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';

/** Persistierte Theme-Praeferenz; ohne Wahl startet die Konsole dunkel. */
function initialTheme(): 'light' | 'dark' | 'system' {
  try {
    const v = localStorage.getItem('sec-theme');
    if (v === 'light' || v === 'dark') return v;
  } catch {
    /* storage optional */
  }
  return 'dark';
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* IGA war bisher immer dunkel — Dark bleibt Default, Toggle in der Shell. */}
      <ThemeProvider defaultTheme={initialTheme()} defaultLanguage="de">
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
